import React from 'react';

function classNames(...classes: string[]) {
	return classes.filter(Boolean).join(' ');
}

const ChatBotTabs: React.FC = () => {
	return (
		<div>
			<div className="px-4">
				Response script...
				<div className="mt-2 mb-4 flex rounded-md shadow-sm">
					<div className="relative flex flex-grow items-stretch focus-within:z-10">
						<input
							type="text"
							// value={userInput}
							// onChange={(e) => setUserInput(e.target.value)}
							className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
							placeholder="Enter text"
						/>
					</div>
					<button
						type="button"
						// onClick={handleSendMessage}
						className="relative -ml-px inline-flex bg-black items-center rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-500"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" className="w-4 h-4">
							<path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
						</svg>
					</button>
				</div>
			</div>
		</div>
	);
};

export default ChatBotTabs;
